export default {"src":"/_next/static/media/home-offer-strip.b5614e38.svg","height":85,"width":154};